import { render, staticRenderFns } from "./MeasurementsSettings.vue?vue&type=template&id=e20bc7dc&"
import script from "./MeasurementsSettings.vue?vue&type=script&lang=js&"
export * from "./MeasurementsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports